import React from "react";
import {CircularProgress} from "@material-ui/core";
import {useCustomBackdropLoaderStyles} from "./useStyles";

const CustomBackdropLoader = ({ text, style }) => {
    const classes = useCustomBackdropLoaderStyles();

    return(
        <div style={style} className={classes.container}>
            <CircularProgress/>
            {text ? <span className={classes.text}>{text}</span> : null}
        </div>
    );
};

export default CustomBackdropLoader;